export enum Frequency {
  // 每天
  EVERY_DAY = 1,
  // 每3天
  EVERY_DAY_OF_THREE = 2,
  // 每周
  EVERY_WEEK = 3,
  // 每月
  EVERY_MONTH = 4,
}
export type FrequencyKeys = keyof typeof Frequency
export type FrequencyValues = (typeof Frequency)[FrequencyKeys]
export const frequencyText: Record<FrequencyValues,string> = {
  1: '每天',
  2: '每3天',
  3: '每周',
  4: '每月',
}
export enum UpdateStatus {
  UpdateSuccess = 1,
  UpdateFailed = 2,
  Updating = 3,
}
export type UpdateStatusKeys = keyof typeof UpdateStatus
export type UpdateStatusValues = (typeof UpdateStatus)[UpdateStatusKeys]
export const UpdateStatusText: Record<UpdateStatusValues,string> = {
  1: '更新成功',
  2: '更新失败',
  3: '更新中',
}
export const UpdateStatusColor: Record<UpdateStatusValues,string> = {
  1: 'var(--el-color-success)',
  2: 'var(--el-color-danger)',
  3: 'var(--el-color-primary)',
}
export const UpdateStatusIcon: Record<UpdateStatusValues,string> = {
  /** 更新成功 */
  1: 'assets/icons/update-success',
  /** 更新失败 */
  2: 'assets/icons/update-fail',
  /** 更新中 */
  3: 'assets/icons/updating',
}
export enum UpdateType {
  ALL = 0,
  UpdateByHand = 1,
  UpdateByTime = 2,
  UpdateByOffLine = 3,
}
export type UpdateTypeKeys = keyof typeof UpdateType
export type UpdateTypeValues = (typeof UpdateType)[UpdateTypeKeys]
export const UpdateTypeText: Record<UpdateTypeValues,string> = {
  0: '全部',
  1: '手动更新',
  2: '定时更新',
  3: '离线更新'
}
export enum StateType {
  // 启用
  Allowed = 1,
  // 禁用
  Rejected = 2,
}
export type StateTypeKeys = keyof typeof StateType
export type StateTypeValues = (typeof StateType)[StateTypeKeys]

export const StateTypeText: { [P in StateTypeValues]: string } = {
  1: '启用',
  2: '禁用',
}
export enum UpdateStateType {
  ToBeUpdated = 1,
  LastVersion = 2,
  Updating = 3,
}
export type UpdateStateTypeKeys = keyof typeof UpdateStateType
export type UpdateStateTypeValues = (typeof UpdateStateType)[UpdateStateTypeKeys]
export const updateStateTypeText = {
  1: '可更新版本',
  2: '已是最新版',
  3: '更新中',
}
export const updateStateTypeIcon = {
  1: 'el-icon-refresh',
  2: '',
  3: 'el-icon-loading'
}
